;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { jwtDecode } from "jwt-decode";
import type { User } from "@/types/auth";

type DecodedUserToken = Pick<User, "email" | "role"> & {
	user_id: string;
	organizationId: string;
	exp: number;
};

export function decodeUserJwtToken(token: string) {
	const decoded = jwtDecode<DecodedUserToken>(token);

	return decoded;
}
